import React, {Component} from 'react';
import { SideModal } from '../components/BioPedModal';
import './HelpDialog.css';
import helpScreen from '../images/help.jpg';
import IconWithCaption from '../components/IconWithCaption';

export default class HelpDialog extends Component{
    render(){
        return(
            <SideModal className='help-modal' {...this.props}>
                    <div className='title-bar'>
                        <div className='table hmax vmax align-middle'>
                            <div>
                                <div><span>&copy;BioPed Franchising Inc. All rights reserved.</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span><a href='#'>Version Info</a></span></div>
                                <div className='align-right'><IconWithCaption icon='help' caption='help' className='header-help-btn' onClick={() => this.props.onRequestClose()} /></div>
                            </div>                        
                        </div>
                    </div>
                    
                    <div className='content'>
                    <div className='close-btn' onClick={() => this.props.onRequestClose()}>Close</div>
                    <h1>Help</h1>
                    
                        <h3>View appointments by Day or Week:</h3>
                        <ul>
                            <li>Toggle Day button to provide a daily view of your schedule. To view one day backwards or one day forward on your schedule, use the "Last" and "Next" arrows at the top of the schedule</li>
                            <li>Toggle Week button to provide a weekly view of your schedule. To view one week backwards or one week forward on your schedule, use the Last and Next arrows at the top of the schedule.</li>
                            <li>To move quickly through the months (forward or backwards), click on the date (between the Last and Next buttons). A calendar will pop up. Click on the left or right black arrows to move through months.</li>
                        </ul>


                        <h3>To Create a new appointment:</h3>
                        <ul>
                            <li>The schedule is divided into 15 minute increments.</li>
                            <li>To add a new appointment, double click on a time slot. A pop-up will appear.</li>
                            <li>In the “Client” field, type in an existing client and complete the remaining fields. You can also add a note at the bottom of the pop-up.</li>
                            <li>Click on the Save button to save this appointment.</li>
                            <li>Click on the Cancel button if you do not wish to save this appointment.</li>
                        </ul>


                        <h3>To Edit an existing appointment:</h3>
                        <ul>
                            <li>To Edit an existing appointment, double click on the appointment displayed on your schedule. A pop-up will appear.</li>
                            <li>Edit the information as needed.</li>
                            <li>Click on the Save button to save this appointment.</li>
                            <li>Click on the Cancel button if you do not wish to save any edits to this appointment.</li>
                            <li>Click on the Delete button if you wish to remove this appointment from your schedule.</li>
                        </ul>


                        <h3>To Add an individual as a column on your schedule:</h3>
                        <ul>
                            <li>Click on the "+" icon at the top left hand corner of the schedule.</li>
                        </ul>
                        Note: This icon will only be displayed if there are individuals who have not yet been added to the schedule. Hovering over this icon will display the names of remaining individuals. Click on the name to be added and a new column will be created.<br/>

                        <h3>To Remove an individual's column on your schedule:</h3>
                        <ul>
                            <li>Click on the "x" icon to the right of the individual's name.</li>
                        </ul>
                    
                    </div>
                
            </SideModal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/HelpDialog.js